export interface RedSocial {
  id: number;
  nombre: string;
  url: string;
  icono: string;
  colorClass: string;
}

export const redesSociales: RedSocial[] = [
  { id: 1, nombre: "YouTube", url: "https://youtube.com", icono: "ri-youtube-fill", colorClass: "bg-social-youtube" },
  { id: 2, nombre: "Facebook", url: "https://www.facebook.com/profile.php?id=61586569725415", icono: "ri-facebook-fill", colorClass: "bg-social-facebook" },
  { id: 3, nombre: "Instagram", url: "https://www.instagram.com/masmed_tarapaca", icono: "ri-instagram-fill", colorClass: "bg-social-instagram" },
  { id: 4, nombre: "X", url: "https://x.com", icono: "ri-twitter-x-fill", colorClass: "bg-masmed-gray-900" },
  { id: 5, nombre: "LinkedIn", url: "https://linkedin.com", icono: "ri-linkedin-fill", colorClass: "bg-social-linkedin" },
];